<template>
  <div class="wrapper">
    <div class="top-bar">
      <div class="top-bar-left" @click="backToResearch()">
        <i class="el-icon-back"></i>统计
      </div>
    </div>
    <div class="content">
      <div class="mdc">
        <div class="d-header">
          <div class="score-count">
            <div class="avg-score">得分：{{ avgScore }}</div>
            <div>有效评分人次：{{ commentUserCount }}</div>
            <div>最高分：{{ maxScore }}</div>
            <div>最低分：{{ minScore }}</div>
          </div>
          <div class="research-info">
            <div class="border-container-title">课程信息</div>
            <div class="border-container-content">
              <div class="name">{{ activity.name }}</div>
              <div class="name">主讲：{{ activity.lecturer_name }}</div>
              <div>学校：{{ activity.from }}</div>
              <div>
                年级：{{ activity.gradeName }} 丨 学科：{{
                  activity.subjectName
                }}
              </div>
              <div>
                活动时间：{{ activity.startTime + " - " + activity.endTime }}
              </div>
            </div>
          </div>
        </div>
        <div class="count-operate">
          <div
            :class="{ 'count-operate-count': true, select: showCount }"
            @click="showCount = true"
          >
            评分统计
          </div>
          <div>/</div>
          <div
            :class="{ 'count-operate-detail': true, select: !showCount }"
            @click="showCount = false"
          >
            明细
          </div>
        </div>
        <div v-show="showCount" class="count-container">
          <div id="d_chart"></div>
          <div class="tb-container">
            <div style="text-align:right;margin-bottom:8px;">
              <el-button @click="exportCount()">导出</el-button>
            </div>
            
            <el-table
              id="tb_count"
              border
              :data="tableCountData"
              :default-sort="{ prop: 'avgScore', order: 'descending' }"
            >
              <el-table-column prop="name" label="评分项"> </el-table-column>
              <el-table-column
                prop="count"
                label="有效评分人次"
                sortable
                width="200"
              >
              </el-table-column>
              <el-table-column
                prop="maxScore"
                label="最高分"
                sortable
                width="160"
              >
              </el-table-column>
              <el-table-column
                prop="minScore"
                label="最低分"
                sortable
                width="160"
              >
              </el-table-column>
              <el-table-column
                prop="avgScore"
                label="均分"
                sortable
                width="160"
              >
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-show="!showCount" class="detail-container">
           <div style="text-align:right;margin-bottom:8px;">
              <el-button @click="exportDetail()">导出</el-button>
            </div>
           
          <el-table
            id="tb_detail"
            border
            :data="tableDetailData"
            :default-sort="{ prop: 'timeStr', order: 'descending' }"
          >
            <el-table-column prop="name" label="评分人" width="160"></el-table-column>
            <el-table-column prop="role" label="角色" width="80">
            </el-table-column>
            <el-table-column
              prop="timeStr"
              label="评分时间"
              sortable
              width="180"
            >
            </el-table-column>
            <el-table-column
              prop="totalScore"
              label="总分"
              sortable
              width="120"
            >
            </el-table-column>
            <el-table-column
              v-for="columnItem in columnList"
              :key="columnItem.key"
              :prop="columnItem.prop"
              :label="columnItem.label"
            >
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
import FileSaver from "file-saver";
import XLSX from "xlsx";

export default {
  components: {},
  data() {
    return {
      isLoad: false,
      userInfo: null,
      activity: {
        name: "",
        lecturer_name: "",
        from: "",
        gradeName: "",
        subjectName: "",
        startTime: "",
        endTime: "",
      },
      avgScore: 0,
      commentUserCount: 0,
      maxScore: 0,
      minScore: 0,
      commentItemList: [],
      commentRecordList: [],
      showCount: true,
      tableCountData: [],
      tableDetailData: [],
      columnList: [],
    };
  },
  //监听路由变化 控制首页背景图
  watch: {},
  created() {},
  beforeMount() {},
  mounted() {
    console.log(echarts);
    this.activity = JSON.parse(sessionStorage.activity);
    this.userInfo = JSON.parse(sessionStorage.userInfo);
    this.getCommentRecordList();
  },
  methods: {
    formatDate(date, fmt) {
      let ret;
      const opt = {
        "y+": date.getFullYear().toString(), // 年
        "M+": (date.getMonth() + 1).toString(), // 月
        "d+": date.getDate().toString(), // 日
        "H+": date.getHours().toString(), // 时
        "m+": date.getMinutes().toString(), // 分
        "s+": date.getSeconds().toString(), // 秒
      };
      for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
          fmt = fmt.replace(
            ret[1],
            ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
          );
        }
      }

      return fmt;
    },
    backToResearch() {
      this.$router.push("/research");
    },
    getCommentRecordList() {
      this.axios
        .post(`/teacher/research/getCommentRecordList`, {
          teach_activity_uuid: this.activity.uuid,
        })
        .then((res) => {
          if (res.data.code == 1) {
            this.commentItemList = res.data.data.commentItemList;
            this.commentRecordList = res.data.data.recordList;
            console.log(this.commentItemList);
            console.log(this.commentRecordList);
            this.columnList = this.commentItemList.map((x) => {
              return {
                prop: x.uuid,
                label: x.name,
                key: x.uuid,
              };
            });
            this.setCommentScore();
            this.setUserScore();
            this.isLoad = true;
            this.setChart();
          } else {
            this.$message({
              message: res.data.msg,
              type: "success",
              duration: 1500,
              showClose: true,
            });
          }
        });
    },
    setUserScore() {
      let teacherScoreList = [];
      for (let i = 0; i < this.commentRecordList.length; i++) {
        let record = this.commentRecordList[i];
        let teacherScore = teacherScoreList.find(
          (x) => x.teacher_uuid == record.teacher_uuid
        );
        if (teacherScore != null) {
          teacherScore.totalScore += record.score;
          teacherScore.scoreList.push({
            comment_item_uuid: record.teach_activity_comment_item_uuid,
            score: record.score,
          });
        } else {
          teacherScore = {
            teacher_uuid: record.teacher_uuid,
            teacher_name: record.teacher_name,
            time: new Date(record.createtime).getTime(),
            timeStr: this.formatDate(
              new Date(record.createtime),
              "yyyy-MM-dd HH:mm"
            ),
            totalScore: 0,
            scoreList: [],
          };
          teacherScore.totalScore += record.score;
          teacherScore.scoreList.push({
            comment_item_uuid: record.teach_activity_comment_item_uuid,
            score: record.score,
          });
          teacherScoreList.push(teacherScore);
        }
      }

      let tableDetailList = [];
      for (let i = 0; i < teacherScoreList.length; i++) {
        let teacherScore = teacherScoreList[i];
        let tableDetailItem = {
          name: teacherScore.teacher_name,
          role: this.activity.exterp != null && this.activity.exterp.indexOf(teacherScore.teacher_uuid)>-1?'专家':'观众',
          time: teacherScore.time,
          timeStr: teacherScore.timeStr,
          totalScore: 0,
        };

        for (let j = 0; j < this.commentItemList.length; j++) {
          let commentItem = this.commentItemList[j];
          var record = teacherScore.scoreList.find(
            (x) => x.comment_item_uuid == commentItem.uuid
          );
          if (record == null) {
            tableDetailItem[commentItem.uuid] = 0;
          } else {
            tableDetailItem[commentItem.uuid] = record.score;
            tableDetailItem.totalScore += record.score;
          }
        }

        tableDetailList.push(tableDetailItem);
      }
      let totalScoreList = tableDetailList.map((x) => x.totalScore);
      let maxMinAvg = this.maxMinAvg(totalScoreList);
      this.maxScore = maxMinAvg[0];
      this.minScore = maxMinAvg[1];
      this.avgScore = maxMinAvg[2];
      this.commentUserCount = teacherScoreList.length;
      tableDetailList.sort((a, b) => {
        return a.time - b.time;
      });
      this.tableDetailData = tableDetailList;
    },
    setCommentScore() {
      let commentScoreList = [];
      for (let i = 0; i < this.commentItemList.length; i++) {
        let commentItem = this.commentItemList[i];
        let recordList = this.commentRecordList.filter(
          (x) => x.teach_activity_comment_item_uuid == commentItem.uuid
        );
        let scoreList = recordList.map((x) => x.score);
        let maxMinAvg = this.maxMinAvg(scoreList);
        let commentScore = {
          name: commentItem.name,
          count: recordList.length,
          maxScore: maxMinAvg[0],
          minScore: maxMinAvg[1],
          avgScore: maxMinAvg[2],
        };
        commentScoreList.push(commentScore);
      }

      commentScoreList.sort((a, b) => {
        return a.avgScore - b.avgScore;
      });
      this.tableCountData = commentScoreList;
    },
    maxMinAvg(arr) {
      if (arr.length == 0) {
        return [0, 0, 0];
      }
      let max = arr[0];
      let min = arr[0];
      let sum = arr[0];
      for (let i = 1; i < arr.length; i++) {
        if (arr[i] > max) {
          max = arr[i];
        }
        if (arr[i] < min) {
          min = arr[i];
        }
        sum = sum + arr[i];
      }
      let avg = sum / arr.length;
      return [max, min, avg];
    },
    setChart() {
      var myChart = this.$echarts.init(document.getElementById("d_chart"));
      let source = [];
      source.push(["product", "均分", "最高分", "最低分"]);
      for (let i = 0; i < this.tableCountData.length; i++) {
        let countItem = this.tableCountData[i];
        source.push([
          countItem.name,
          countItem.avgScore,
          countItem.maxScore,
          countItem.minScore,
        ]);
      }
      let option = {
        legend: {},
        tooltip: {},
        dataset: {
          // 提供一份数据。
          source: source,
        },
        // 声明一个 X 轴，类目轴（category）。默认情况下，类目轴对应到 dataset 第一列。
        xAxis: { type: "category" },
        // 声明一个 Y 轴，数值轴。
        yAxis: {},
        // 声明多个 bar 系列，默认情况下，每个系列会自动对应到 dataset 的每一列。
        series: [{ type: "bar" }, { type: "bar" }, { type: "bar" }],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    setTableCountData() {},
    setTableDetailData() {},
    exportCount(){
       var xlsxParam = { raw: true } // 导出的内容只做解析，不进行格式转换
      var wb = XLSX.utils.table_to_book(document.querySelector('#tb_count'), xlsxParam)

      /* get binary string as output */
      var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
      try {
        FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '评分统计.xlsx')
      } catch (e) {
        if (typeof console !== 'undefined') {
          console.log(e, wbout)
        }
      }
      return wbout
    },
    exportDetail(){
 var xlsxParam = { raw: true } // 导出的内容只做解析，不进行格式转换
      var wb = XLSX.utils.table_to_book(document.querySelector('#tb_detail'), xlsxParam)

      /* get binary string as output */
      var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
      try {
        FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '评分明细.xlsx')
      } catch (e) {
        if (typeof console !== 'undefined') {
          console.log(e, wbout)
        }
      }
      return wbout
    }
  },
};
</script>

<style scoped>
.wrapper {
  margin: 0px auto;
  height: calc(100vh - 142px);
  overflow: auto;
  width: 75vw;
  padding-top: 10px;
  position: relative;
}
.top-bar {
  padding: 8px 16px;
  height: 44px;
  overflow: hidden;
  position: relative;
  background-color: white;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}

.top-bar-left {
  position: absolute;
  top: 8px;
  line-height: 44px;
  left: 16px;
  cursor: pointer;
}
.top-bar-right {
  position: absolute;
  top: 8px;
  right: 16px;
}

.content {
  height: calc(100vh - 212px);
  border: 2px solid #f6f6f6;
  overflow: auto;
  background-color: white;
}
.mdc {
  background-color: white;
  padding: 16px;
  height: calc(100vh - 248px);
  margin-top: 4px;
  display: flex;
  flex-direction: column;
}

.d-header {
  display: flex;
}

.research-info {
  flex: 1;
}

.score-count {
  width: 140px;
  height: 100px;
  padding: 16px;
  border: 1px solid #ddd;
  border-radius: 10px;
  font-size: 14px;
  line-height: 28px;
}

.score-count .avg-score {
  font-size: 18px;
  font-weight: bold;
}
.research-info {
  margin-left: 32px;
  font-size: 12px;
}

.border-container-title {
  color: #409eff;
  font-size: 14px;
}
.border-container-content {
  font-size: 12px;
  line-height: 24px;
}

.border-container-content .name {
  font-weight: bold;
}

.count-operate {
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  margin-top: 16px;
  margin-left: 4px;
}

.count-operate .select {
  color: #409eff;
  text-decoration: underline;
}

.detail-container {
  margin-top: 16px;
  margin-bottom:16px;
}

.count-container {
  margin-top: 16px;
  margin-bottom:16px;
}

#d_chart {
  width: 100%;
  height: 250px;
  background-color: white;
}
</style>
